/* tslint:disable */
/* eslint-disable */
/**
 * Pet Profile A Service
 * Pet Profile A Layer Service For more information or information on how this data maps to the kryios data see [here](https://chewyinc.atlassian.net/wiki/spaces/MPROD/pages/1957927091/Pet+Property+to+Data+Mapping)
 *
 * The version of the OpenAPI document: 1.0
 * Contact: DL-IT_Pet_Profile@chewy.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FormButtonModel } from './FormButtonModel';
import {
    FormButtonModelFromJSON,
    FormButtonModelFromJSONTyped,
    FormButtonModelToJSON,
} from './FormButtonModel';

/**
 * 
 * @export
 * @interface PetV2FormActionModel
 */
export interface PetV2FormActionModel {
    /**
     * 
     * @type {FormButtonModel}
     * @memberof PetV2FormActionModel
     */
    save?: FormButtonModel;
    /**
     * 
     * @type {FormButtonModel}
     * @memberof PetV2FormActionModel
     */
    remove?: FormButtonModel;
}

/**
 * Check if a given object implements the PetV2FormActionModel interface.
 */
export function instanceOfPetV2FormActionModel(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function PetV2FormActionModelFromJSON(json: any): PetV2FormActionModel {
    return PetV2FormActionModelFromJSONTyped(json, false);
}

export function PetV2FormActionModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): PetV2FormActionModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'save': !exists(json, 'save') ? undefined : FormButtonModelFromJSON(json['save']),
        'remove': !exists(json, 'remove') ? undefined : FormButtonModelFromJSON(json['remove']),
    };
}

export function PetV2FormActionModelToJSON(value?: PetV2FormActionModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'save': FormButtonModelToJSON(value.save),
        'remove': FormButtonModelToJSON(value.remove),
    };
}

